import PasswordInput from './PasswordInput'
import fillPasswordInput from './testHelper/fillPasswordInput'
import expectPasswordInputValue from './testHelper/expectPasswordInputValue'

export default PasswordInput
export { fillPasswordInput, expectPasswordInputValue }
